import { and, ControlProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { InputLabel } from '@material-ui/core'
import { useBlockUpdatesWhileFocused } from 'elements/hooks/useBlockUpdatesWhileFocused'
import { styled, TextField } from 'opensolar-ui'

const tester = rankWith(100, and(uiTypeIs('JsonEditor')))

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
})

const HeaderRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  width: '100%',
  alignItems: 'center',
})

const Label = styled(InputLabel)({
  flexGrow: 1,
  position: 'unset',
})

const JsonEditorRenderer = (props: ControlProps) => {
  const onChangeParse = (event) => {
    let parsed = null
    try {
      parsed = JSON.parse(event.target.value)
    } catch (e) {
      // not valid json, don't change the value
      return
    }
    props.handleChange(props.path, parsed)
  }
  const editor = (
    <JsonInput
      value={JSON.stringify(props.data, null, 2)}
      onChange={onChangeParse}
      rows={props.uischema.options?.rows}
    />
  )
  return (
    <Container>
      <HeaderRow>
        {/* TODO: fix me, only accept string but label could be something else */}
        <Label>{props.label as string}</Label>
      </HeaderRow>
      {editor}
      <HeaderRow>
        <Label>{props.description}</Label>
      </HeaderRow>
    </Container>
  )
}

interface JsonInputProps {
  value: string
  onChange: (event: any) => void
  rows?: number
}

const JsonInput = ({ value, onChange, rows = undefined }: JsonInputProps) => {
  const props = useBlockUpdatesWhileFocused({ value, onChange })
  return <TextField className="code-block" {...props} multiline rows={rows} />
}

const renderer = withJsonFormsControlProps(JsonEditorRenderer)

export default {
  tester,
  renderer,
}
